<template>
    <b-card :header-class="`border-status ${(selectedEmpresa.insured_status  === 'BLOCKED') ? 'bd-warning' : ((selectedEmpresa.insured_status  === 'UNBLOCKED') ? 'bd-success' : '')}`">
        <div slot="header">
            <a class="p-0" v-b-tooltip.hover @click="blockCompany(selectedEmpresa)"
                :title="(selectedEmpresa.insured_status === 'BLOCKED') ? 'Liberar empresa' : 'Asegurar empresa'">
                <i v-if="selectedEmpresa.insured_status === 'BLOCKED'"
                    class="fa fa-times-circle-o fa-lg mr-1"/>
                <i v-if="selectedEmpresa.insured_status === 'UNBLOCKED' || selectedEmpresa.insured_status === 'NOT_APPLICABLE' || selectedEmpresa.insured_status === null"
                    class="fa fa-check-circle-o fa-lg mr-1"/>
            </a>
          <span class="font-weight-bold">
            {{ selectedEmpresa.id ? selectedEmpresa.nombre : "Empresa" }}</span
          >
          <b-button
            @click="backRoute()"
            size="sm"
            variant="secondary"
            class="float-right"
          >
            <i class="fa fa-reply fa-lg" /> Volver
          </b-button>
        </div>

        <el-select
          v-model="tab_activo"
          :disabled="accion === 'create'"
          filterable
          class="mb-2 b-select-modules"
        >
            <el-option
              v-for="(componente, indice) in componentsFilters"
              :key="indice"
              :label="componente.texto"
              :value="indice"
            />
        </el-select>



        <b-tabs
          pills card vertical
          v-model="tab_activo"
          class="b-tabs-sp" nav-wrapper-class="w-40" no-key-nav lazy
        >
            <b-tab
              v-for="(componente, indice) in componentsFilters"
              :key="indice"
              :title="componente.texto"
              :title-item-class="componente.visible ? '' : 'd-none'"
              @click="onHandleClickTab(indice)"
            >
            <component
              style="width: auto"
              v-bind:is="componente.componente"
              v-if="indice === tab_activo"
              v-bind="componente.props"
            />
          </b-tab>
        </b-tabs>
        <create-blocked @data-event="eventBlockCompany"/>
      </b-card>

    </template>

    <script>

    // Importaciones generales
    import { mapState, mapMutations, mapActions } from "vuex";

    // Componentes
    import imagen from "./Imagen";
    import usuarios from "./usuarios";
    import etiquetas from "./Etiquetas";
    import camposPersonalizados from "./CamposPersonalizados";
    import diseno from "./Diseno";
    import AsignacionRPQ from "./rqp/AsignacionRPQ";
    import ubicaciones from "./ubicaciones";
    import contratistas from "./Contratistas";
    import tarjetasEmergencia from "./TarjetasEmergencia";
    import adjuntosDescarga from "./AdjuntosDescarga";
    import etiquetasDescarga from "./EtiquetasDescarga";
    import home from "./home";
    import generales from "./generales";
    import licencias from "./licencias";
    import providers from "./providers";
    import locations from "./Locations";
    import configurableVariables from './ConfigurableVariables/Index'
    import CreateBlocked from '../empresa/company_blockades/CreateBlocked';
    import roles from './roles/Index'
    import sites from './sites/Index'
    import positions from '../workers/positions/index.vue'
    import training_companies from '../workers/training_companies/index.vue'
    import trainings from '../workers/trainings/index.vue'
    import areas from '../workers/areas/index.vue'
    import ges from '../risk_analysis/hygienic_measurements/index.vue'
    import epps from './epps/Index'

    // Helpers
    import { getAcls } from "../../plugins/acl";

    export default {
      name: "formulario-empresa",
      components: {
        imagen,
        usuarios,
        etiquetas,
        camposPersonalizados,
        diseno,
        AsignacionRPQ,
        ubicaciones,
        contratistas,
        tarjetasEmergencia,
        adjuntosDescarga,
        etiquetasDescarga,
        home,
        generales,
        licencias,
        locations,
        providers,
        configurableVariables,
        CreateBlocked,
        roles,
        sites,
        positions,
        training_companies,
        areas,
        ges,
        epps,
      },
      data() {
        return {
          tab_activo: this.tabActiveCompany,
        };
      },
      watch: {
          '$route.params.id'(newId, oldId) {
              if (newId !== oldId) {
                  this.loadAndValidateData(newId);
              }
          }
      },
      async created() {
        await this.loadAndValidateData(this.$route.params.id);
      },
      mounted() {
        this.initializeComponent();
      },
      methods: {
        ...mapActions("empresa", ["datosEmpresa", "showValidateCompany"]),
        ...mapMutations("dashboard", ["load",'setTabActive']),
        ...mapMutations("empresa", ["setAccion", "resetSelectedEmpresa", "validateCompanyUrl"]),
        ...mapMutations("licencias", ["resetFiltros", "establecerLicencias"]),
        ...mapMutations("productos_emp", [
          "asignaEmpresa",
          "resetFiltro",
          "resetProducts",
        ]),
        ...mapMutations("empresa", [
          "resetUserFilter",
          "resetListadoUsuario",
          "resetImagen",
          "resetDiseno",
          "resetMensaje",
          "resetCamposPersonalizados",
          "resetParamsContratista",
        ]),
        ...mapMutations("ubicacion", [
          "resetFiltroUbicaciones",
          "resetFiltroNiveles",
        ]),
        ...mapMutations("etiquetas", ["resetVisualEmpresa"]),
        ...mapMutations("adjuntos", ["resetSelectedAdjunto"]),
        ...mapMutations("home", ["resetBannerEmpresa"]),
        ...mapMutations("configTarjetasEmergencia", [
          "resetdefaultTarjetasEmergencia",
        ]),
        ...mapActions('companyBlockades', ['blockCompany']),

        // Mutaciones del modulo Configuración de países
        ...mapMutations('configurableVariables', {
          resetFilterConfigurableVariables: 'setFilter'
        }),
        _validarPermiso(permiso) {
          const acls = getAcls();

          return !!acls.permisos.find((p) => p === permiso);
        },
        async loadAndValidateData(companyId) {
            await this.showValidateCompany(companyId);
            this.validateCompanyUrl(companyId);

            if (!this.validateCompany && this.$route.path !== "/inicio") {
                this.$router.push("/inicio");
            }

            this.setTabActiveLocal();
        },
        initializeComponent() {
            this.resetSelectedEmpresa();
            this.setAccion("create");

            if (this.$route.params.id) {
                this.setAccion("update");
            }
            this.load(false);
        },
        /**
         * Clic en los tabs.
         *
         * @author Fernando Claros
         */
        onHandleClickTab(indice) {
            const nameComponent = this.componentsFilters[indice].texto;
            if (nameComponent === "Configuración de países") this.resetFilterConfigurableVariables();
        },
        setTabActiveLocal() {
          this.tab_activo = this.tabActiveCompany;
        },
        backRoute(){
            this.setTabActive(0);
            const currentPath = this.$route.path;
            if (currentPath.includes("/my-company")) {
              this.$router.go(-1);
            }else {
              this.$router.push("/empresas");
            }
        },
        async eventBlockCompany(){
            await this.datosEmpresa(this.$route.params.id);
        }
      },
      computed: {
        componentsFilters() {
            return this.componentes.filter(componente => componente.visible);
        },
        componentes() {
            return [
              {
                texto: "Generales",
                componente: generales,
                visible: this._validarPermiso('empresa-ver-generales'),
              },
              {
                texto: "Licencias",
                componente: licencias,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-licencias'),
                props: { company: this.selectedEmpresa }
              },
              {
                texto: "RPQ",
                componente: AsignacionRPQ,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-rpq'),
              },
              {
                texto: "Usuarios",
                componente: usuarios,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-usuarios'),
              },
              {
                texto: "Imágenes",
                componente: imagen,
                props: { contratista: 0 },
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-imagenes'),
              },
              {
                texto: "Diseño",
                componente: diseno,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-diseño'),
              },
              {
                texto: "Etiquetas",
                componente: etiquetas,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-etiquetas'),
              },
              {
                texto: "Campos personalizados",
                componente: camposPersonalizados,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-campos-personalizados'),
              },
              {
                texto: "Tarjetas emergencia",
                componente: tarjetasEmergencia,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-tarjetas-emergencia'),
              },
              {
                texto: "Contratistas",
                componente: contratistas,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-contratistas'),
              },
              {
                texto: "Home",
                componente: home,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-home'),
              },
              {
                texto: "Descarga adjuntos",
                componente: adjuntosDescarga,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-descarga-adjuntos'),
              },
              {
                texto: "Descarga masivas",
                componente: etiquetasDescarga,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-descarga-masivas'),
              },
              {
                texto: "Ubicaciones",
                componente: locations,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-ubicaciones'),
              },
              {
                texto: "Proveedores",
                componente: providers,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-proveedores'),
              },
              {
                texto: "Configuración de países",
                componente: configurableVariables,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-variables-configurables'),
              },
              {
                texto: "Roles",
                componente: roles,
                visible:
                    this.accion !== "create" &&
                    this.conexion === 1 &&
                    this._validarPermiso('empresa-ver-roles'),
              },
              // {
              //   texto: "Locaciones",
              //   componente: sites,
              //   visible:
              //       this.accion !== "create" &&
              //       this.conexion === 1 &&
              //       this._validarPermiso('empresa-ver-locaciones'),
              // },
              {
                texto: "Cargos",
                componente: positions,
                visible:
                    this.accion !== "create" &&
                    this.conexion === 1 &&
                    this._validarPermiso('empresa-ver-cargos'),
              },
              {
                texto: "Empresas formadoras",
                componente: training_companies,
                visible:
                    this.accion !== "create" &&
                    this.conexion === 1 &&
                    this._validarPermiso('empresa-ver-empresas-formadoras'),
              },
              {
                texto: "Capacitaciones",
                componente: trainings,
                visible:
                    this.accion !== "create" &&
                    this.conexion === 1 &&
                    this._validarPermiso('empresa-ver-capacitaciones'),
              },
              // {
              //   texto: "Áreas",
              //   componente: areas,
              //   visible:
              //       this.accion !== "create" &&
              //       this.conexion === 1 &&
              //       this._validarPermiso('empresa-ver-areas'),
              // },
              {
                texto: "GES",
                componente: ges,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-ges'),
              },
              {
                texto: "EPP",
                componente: epps,
                visible:
                  this.accion !== "create" &&
                  this.conexion === 1 &&
                  this._validarPermiso('empresa-ver-epps'),
              }
            ];
        },
        ...mapState("empresa", ["selectedEmpresa", "accion", "conexion", "validateCompany", 'selectedImagen']),
        ...mapState("dashboard", ["tabActiveCompany"]),
      },
      beforeDestroy() {
        this.resetFiltros();
        this.establecerLicencias({ data: [] });
        this.asignaEmpresa(this.$route.params.id);
        this.resetFiltro();
        this.resetProducts();
        this.resetUserFilter();
        this.resetListadoUsuario();
        if (!localStorage.getItem('my_company') || localStorage.getItem('my_company') === null || localStorage.getItem('my_company') === undefined) this.resetImagen();
        this.resetFiltroUbicaciones();
        this.resetFiltroNiveles();
        this.resetDiseno();
        this.resetMensaje();
        this.resetCamposPersonalizados();
        this.resetdefaultTarjetasEmergencia();
        this.resetParamsContratista();
        this.resetBannerEmpresa();
        this.resetSelectedAdjunto();
        this.resetVisualEmpresa();
      },
    };
    </script>

    <style>


    .b-tabs-sp .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
      color: #fff;
      background-color: #32696e;
    }

    .b-tabs-sp .nav-pills a {
      color: #32696e;
    }
    .border-status{
        border-top: 3px solid #c8ced3;
    }
    .bd-success{
        border-top-color: #4dbd74;
    }
    .bd-warning{
        border-top-color: #ffc107;
    }

    @media only screen and (max-width: 1433px) {
      .b-tabs-sp .nav-pills {
        display: none !important;
      }
    }

    @media only screen and (min-width: 1433px) {
      .b-select-modules{
        display: none !important;
      }
    }

    @media (min-width: 1433px) and (max-width: 1684px) {
      .tab-content {
        min-width: 900px;
        overflow-x: auto;
      }
    }



    </style>
